import { useMutation, useQuery } from "@tanstack/react-query";
import { SectionDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { SectionClient } from "../../../services/proxies";
import { SearchDto } from "../../../assets/utils/lib/searchDto";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace SectionService {
  const sectionClient = new SectionClient();

  export const save = () =>
    useMutation<IActionResult<SectionDto>, Error, SectionDto>({
      mutationFn: async (payload: SectionDto) => {
        return await sectionClient.SaveSectionAsync(payload);
      },
    });

  export const getSectionQuery = (sectionId: string | undefined) =>
    useQuery({
      queryKey: ["questionnaireSectionQuery", sectionId],
      queryFn: async () => await sectionClient.getSectionAsync(sectionId),
      enabled: Boolean(sectionId && sectionId !== Constants.emptyGuid),
    });

  export const gridQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["questionnaireSectionGridQuery", searchQuery],
      queryFn: async () => await sectionClient.SearchSectionAsync(searchQuery),
    });

  export const deleteSection = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await sectionClient.deleteSectionAsync(id);
      },
    });
}
